/** sessionStorage key for the active OIDC interaction uid. */
export const OIDC_INTERACTION_KEY = "oidc_interaction_uid";

/**
 * Resolve the OIDC interaction uid for this login session.
 * Query param wins and is written to sessionStorage. If the query string is
 * dropped (refresh edge cases, soft nav), the stored uid keeps the form on
 * the OIDC finish path instead of falling through to `/api/login/shopify`.
 *
 * Call {@link clearInteractionUid} after a successful finish or when the
 * interaction is confirmed expired/invalid.
 */
export function resolveInteractionUid() {
  let fromQuery = "";
  try {
    fromQuery = new URLSearchParams(window.location.search).get("interaction") || "";
  } catch {
    fromQuery = "";
  }

  if (fromQuery) {
    try {
      sessionStorage.setItem(OIDC_INTERACTION_KEY, fromQuery);
    } catch {
      /* private mode / quota — query param still works for this page load */
    }
    return fromQuery;
  }

  return peekStoredInteractionUid();
}

export function clearInteractionUid() {
  try {
    sessionStorage.removeItem(OIDC_INTERACTION_KEY);
  } catch {
    /* ignore */
  }
}

/** Pending uid from storage only (does not clear). Used as a guard in login(). */
export function peekStoredInteractionUid() {
  try {
    return sessionStorage.getItem(OIDC_INTERACTION_KEY) || "";
  } catch {
    return "";
  }
}
